export const userData = (obj) => ({
  type: 'USER_DATA',
  obj
})
